<template>
  <div class="text-right">
    <div v-if="show">
      <small
        class="text-muted d-block contract-balance-label"
      >Balance</small>
      <div
        class="skeleton"
        style="width: 120px; height: 32px"
      />
    </div>
    <div v-else>
      <small
        class="text-muted d-block contract-balance-label"
      >Balance</small>
      <h3
        v-if="balance_pesos > 0"
        class="mb-0 text-danger contract-balance-amount"
      >
        RD$ {{ balance_pesos }}
      </h3>
      <h3
        v-else
        class="mb-0 text-success contract-balance-amount"
      >
        Al día
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      show: true,
      balance_pesos: 0,
    }
  },
  created() {
    this.searchBalance()
  },
  methods: {
    searchBalance() {
      if (this.idcontrato > 0) {
        this.$http
          .get("/contrato-balance", {
            params: {
              idcontrato: this.idcontrato,
              idusuario: this.userData.id,
              opresumen: 1,
            },
          })
          .then((response) => {
            this.show = false
            if (response.data) {
              this.balance_pesos = response.data.balance_pesos
            }
          })
          .catch((error) => {
            this.show = false
            console.log(error)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-balance-label {
    font-size: 0.78125rem;
}

.contract-balance-amount {
    font-size: 1.75rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}
</style>
